import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { Close, Sizes } from "@/components/icon/IconList";
import AnchorDrawer from "@/components/modal/AnchorDrawer";
import { Button } from "@bookips/solvook-ui-library";
import { Box, Typography } from "@mui/material";
import BrandCategory from "./BrandCategory";
export const BrandCategoryDrawer = (param)=>{
    let { open , handleClose  } = param;
    return /*#__PURE__*/ _jsxs(AnchorDrawer, {
        anchor: "right",
        open: open,
        onClose: ()=>handleClose(),
        sx: (theme)=>({
                ".MuiPaper-root": {
                    width: "400px",
                    overflowY: "auto !important",
                    [theme.breakpoints.down("sm")]: {
                        width: "85% !important"
                    }
                }
            }),
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                sx: {
                    width: "100%",
                    padding: "16px 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subtitle1",
                        children: "브랜드 카테고리"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "text",
                        startIcon: /*#__PURE__*/ _jsx(Icon, {
                            icon: Close,
                            size: Sizes.xmedium
                        }),
                        onClick: handleClose,
                        sx: {
                            width: "20px",
                            height: "20px",
                            minWidth: "initial"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(BrandCategory, {
                onClose: ()=>handleClose()
            })
        ]
    });
};
